var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "detail-padding padding-nav" },
    [
      _c(
        "el-button",
        {
          staticClass: "upper",
          staticStyle: { "margin-bottom": "0.16rem" },
          attrs: { type: "text", icon: "el-icon-d-arrow-left" },
          on: { click: _vm.goback },
        },
        [_vm._v("Go back")]
      ),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "common-card" }, [
        _c(
          "div",
          {
            staticClass: "spaceLeft",
            staticStyle: { "margin-bottom": "0.3rem" },
          },
          [
            _c("div", { staticClass: "detail_no" }, [
              _vm._v("No." + _vm._s(_vm.pageData.id)),
            ]),
            _vm._v(" "),
            _c("el-tooltip", { attrs: { effect: "light", placement: "top" } }, [
              _c(
                "div",
                {
                  staticClass: "tip_con",
                  attrs: { slot: "content" },
                  slot: "content",
                },
                [_vm._v(_vm._s(_vm.pageData.title))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "detail_title ellipsis" }, [
                _vm._v(_vm._s(_vm.pageData.title)),
              ]),
            ]),
            _vm._v(" "),
            _c("vote-status-comp", {
              attrs: {
                status: _vm.pageData.status,
                over: _vm.pageData.over,
                cumulative: _vm.pageData.vote,
                threshold: _vm.threshold,
              },
              on: {
                "update:status": function ($event) {
                  return _vm.$set(_vm.pageData, "status", $event)
                },
                "update:over": function ($event) {
                  return _vm.$set(_vm.pageData, "over", $event)
                },
                "update:cumulative": function ($event) {
                  return _vm.$set(_vm.pageData, "vote", $event)
                },
                "update:threshold": function ($event) {
                  _vm.threshold = $event
                },
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "spaceLeft" }, [
          _c("div", { staticStyle: { "min-width": "5rem", flex: "1 0 0" } }, [
            _c("div", { staticClass: "detail-item spaceLeft" }, [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("Proposer :"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "detail-text-white" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.pageData.proposer) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item spaceLeft" }, [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("Start Block :"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "detail-text-white" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.pageData.startBlock) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "detail-item spaceLeft" }, [
              _c("span", { staticClass: "detail-item-label" }, [
                _vm._v("End Block :"),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "detail-text-white" }, [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.pageData.endBlock) +
                    "\n          "
                ),
              ]),
            ]),
            _vm._v(" "),
            _vm.pageData.discussionUrl
              ? _c(
                  "div",
                  { staticClass: "detail-item flexStart" },
                  [
                    _c("span", { staticClass: "detail-item-label" }, [
                      _vm._v("Discussion :"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-tooltip",
                      { attrs: { effect: "light", placement: "top" } },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "tip_con",
                            attrs: { slot: "content" },
                            slot: "content",
                          },
                          [_vm._v(_vm._s(_vm.pageData.discussionUrl))]
                        ),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "account-url ellipsis",
                            attrs: {
                              target: "_blank",
                              href: _vm.pageData.discussionUrl,
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.pageData.discussionUrl) +
                                "\n            "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "progress_box", staticStyle: { width: "5rem" } },
            [
              _c("vote-progress", {
                attrs: {
                  cumulative: _vm.pageData.totalWeight,
                  threshold: _vm.pageData.threshold,
                },
                on: {
                  "update:cumulative": function ($event) {
                    return _vm.$set(_vm.pageData, "totalWeight", $event)
                  },
                  "update:threshold": function ($event) {
                    return _vm.$set(_vm.pageData, "threshold", $event)
                  },
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "vote" }, [
                _c("span", { staticClass: "vote_label" }, [_vm._v("My vote:")]),
                _vm._v(" "),
                _c(
                  "span",
                  { staticClass: "vote_val" },
                  [
                    _c("big-number", {
                      attrs: { number: _vm.pageData.myVote },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", { staticClass: "vote_unit" }, [_vm._v("UNIT")]),
              ]),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "detail-item spaceLeft",
            staticStyle: { "align-items": "flex-start" },
          },
          [
            _c("span", { staticClass: "detail-item-label" }, [
              _vm._v("Description :"),
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "detail-text-white",
              staticStyle: { flex: "1" },
              domProps: { innerHTML: _vm._s(_vm.pageData.description) },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "common-card" },
        [
          _c(
            "div",
            {
              staticClass: "detail-title-2 detail-text-white",
              staticStyle: { "margin-bottom": "0.16rem" },
            },
            [_vm._v("\n      All Voter\n    ")]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "common-table",
              attrs: { data: _vm.tableList, "highlight-current-row": "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "data1", label: "", width: "50px" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var $index = ref.$index
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.queryParams.total -
                                ((_vm.queryParams.page - 1) *
                                  _vm.queryParams.pageSize +
                                  $index)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "voter",
                  label: "Voter",
                  "show-overflow-tooltip": "",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "weight", label: "UNIT Vote", align: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _c("big-number", { attrs: { number: row.weight } }),
                        _vm._v(" "),
                        _c("span", { staticClass: "td-word-sm" }, [
                          _vm._v("UNIT"),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", { attrs: { width: "200" } }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "timestamp", label: "Time", align: "left" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (ref) {
                      var row = ref.row
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm
                                .moment(row.timestamp)
                                .format("YYYY-MM-DD HH:mm:ss")
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("pagination", {
            attrs: {
              total: _vm.queryParams.total,
              page: _vm.queryParams.page,
              limit: _vm.queryParams.pageSize,
            },
            on: {
              "update:total": function ($event) {
                return _vm.$set(_vm.queryParams, "total", $event)
              },
              "update:page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:limit": function ($event) {
                return _vm.$set(_vm.queryParams, "pageSize", $event)
              },
              pagination: function ($event) {
                return _vm.getList()
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "spaceBetween",
        staticStyle: { "margin-bottom": "0.24rem" },
      },
      [
        _c("div", { staticClass: "spaceLeft" }, [
          _c("div", { staticClass: "detail-title-1" }, [
            _vm._v("Proposal details"),
          ]),
        ]),
      ]
    )
  },
]
render._withStripped = true

export { render, staticRenderFns }